module.exports = __webpack_public_path__ + "img/icon-shopify.f86535b3.svg";